<template>
  <div>
    <ul class="nav nav-pills nav-fill" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="connectivityPackage-tab"
          data-toggle="tab"
          href="#connectivityPackage"
          role="tab"
          aria-controls="connectivityPackage"
          aria-selected="true"
          ><i class="fa fa-dropbox"></i> Connectivity Packages</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="networkRangePackage-tab"
          data-toggle="tab"
          href="#networkRangePackage"
          role="tab"
          aria-controls="networkRangePackage"
          aria-selected="true"
          ><i class="fa fa-plus-square"></i> Network Range Packages</a
        >
      </li>
       <li v-if="hasAdditionalBilling" class="nav-item">
        <a
          class="nav-link"
          id="additionalPackage-tab"
          data-toggle="tab"
          href="#additionalPackage"
          role="tab"
          aria-controls="additionalPackage"
          aria-selected="true"
          ><i class="fa fa-plus-square"></i> Additional Billing</a
        >
      </li>     
    </ul>
    <div class="tab-content">
      <div
        class="tab-pane active"
        id="connectivityPackage"
        role="tabpanel"
        aria-labelledby="connectivityPackage-tab"
      >
        <ConnectivityPackagePrices
          :productNumber="productNumber"
          :userEditRight="userEditRight"
          :connectivityPackages="connectivityPackages"
          :emptyPackage="emptyPackage"
          @get-connectivity-packages="getUncappedConnectivityPackages"
        />
      </div>
      <div
        class="tab-pane"
        id="networkRangePackage"
        role="tabpanel"
        aria-labelledby="networkRangePackage-tab"
      >
        <NetworkRangePackagePrices
          :productNumber="productNumber"
          :userEditRight="userEditRight"
          :packages="networkRangePackages"
          @getNetworkRangePackages="getNetworkRangePackages"
        />
      </div>
      <div
        v-if="hasAdditionalBilling"
        class="tab-pane"
        id="additionalPackage"
        role="tabpanel"
        aria-labelledby="additionalPackage-tab"
      >
        <AdditionalBillingPricing
          :productNumber="productNumber"
          :userEditRight="userEditRight"
        />
      </div>

    </div>
  </div>
</template>

<script>
import ConnectivityPackagePrices from "@/components/Admin/ConnectivityPackages/ConnectivityPackagePrices";
import NetworkRangePackagePrices from "@/components/Admin/NetworkRangePackages/NetworkRangePackagePrices";
import AdditionalBillingPricing from "@/components/Admin/AdditionalBillingPricing.vue";
export default {
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
    hasAdditionalBilling: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ConnectivityPackagePrices,
    NetworkRangePackagePrices,
    AdditionalBillingPricing,
  },
  data() {
    return {
      connectivityPackages: [],
      networkRangePackages: [],
      emptyPackage: {},
      newPrice: {},
    };
  },
  mounted() {
    this.getUncappedConnectivityPackages();
    this.getNetworkRangePackages();
  },
  methods: {
    getUncappedConnectivityPackages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/connectivitypackages/product/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.connectivityPackages = response.data.connectivitypackages;
            this.emptyPackage = this.deepCopyObject(response.data);
          },
          (error) => {
            this.showError("Error fetching Connectivity Packages", error);
            console.error(error);
          }
        );
    },
    getNetworkRangePackages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/networkrangepackages/product/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.networkRangePackages = response.data;
          },
          (error) => {
            console.error(error);
            this.showError("Error fetching Network Range Packages", error);
          }
        );
    },
  },
};
</script>

<style scoped>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f05050 !important;
}
.nav-pills .nav-link {
  background-color: #f3f2ee;
}
a {
  color: rgba(0, 0, 0, 0.6);
}
</style>